const accordion = document.querySelectorAll('.pricing-table__table-compare_group');
accordion.forEach(item => {
	const title = item.querySelector('.pricing-table__table-compare_title');
	const content = item.querySelector('.pricing-table__table-compare_content');

	title.addEventListener('click', function () {
		content.classList.toggle('show');
		title.classList.toggle('closed');
	});
})



// WEBPACK FOOTER //
// ./scripts/modules/compare-accordion.js